import { connect } from 'react-redux'
import { setLayoutModalInfo } from 'core/templates/actions'
import Finalization from './Finalization'

const mapStateToProps = state => ({
  wizards: state.wizards,
  configurator: state.configurator,
  tradeIn: state.tradeIn
})

const mapDispatchToProps = {
  setLayoutModalInfo
}

export default connect(mapStateToProps, mapDispatchToProps)(Finalization)
